import "../../sass/main.scss";
import {bootPage} from "../app/boot-page";
import {getTranslation} from "../helpers/helpers";

export class Login {
    constructor() {
        this.eventHandlers();
    }

    eventHandlers() {
        $(document.body).on('click', '#wp-submit', this.loginValidation.bind(this));
    }

    loginValidation(e) {
        let userLoginSelector = $("#user_login");
        let userPassSelector = $("#user_pass");
        if ((!userPassSelector.val().length) || (!userLoginSelector.val().length)) {
            let error_msg = null;
            e.preventDefault();
            if ((!userPassSelector.val().length) && (!userLoginSelector.val().length)) {
                error_msg = getTranslation('error_missing_email_and_password');
            } else if ((!userLoginSelector.val().length)) {
                error_msg = getTranslation('error_missing_email');
            } else if ((!userPassSelector.val().length)) {
                error_msg = getTranslation('error_missing_password');
            }
            let error_form_msg_selector = $(".form .error");
            error_form_msg_selector.text(error_msg);
            error_form_msg_selector.addClass("show");
        }
    }
}

bootPage(() => {
    new Login();
});
